var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-banner-wrap"},[_c('div',{staticClass:"mobile-text",attrs:{"id":"title1"}}),_c('div',{staticClass:"mobile-text mobile-text2",attrs:{"id":"title2"}})])
}]

export { render, staticRenderFns }